import React from "react"
import { Table as AntTable } from "antd"
import styled from "styled-components"

import { ExtraButtons } from "../components/extra-buttons"
import { Header } from "../components/layout/header"
import { VisibilityProvider } from "../components/visibility-provider"
import { usePermission,useUpdateHeaderTitle } from "../hooks"
import { EditDrawer } from "../pages-lib/support-channels/edit-drawer"
import { useGetData, useManageItems } from "../pages-lib/support-channels/model"
import { getColumns } from "../pages-lib/support-channels/table-columns"

export default function SupportChannels() {
  const [createDrawerState, setCreateDrawerState] = React.useState(false)
  const [editDrawerState, setEditDrawerState] = React.useState(false)

  const { dataItems, isLoading, options, refetch: getItems } = useGetData()

  const headerTitle = useUpdateHeaderTitle({
    items: dataItems,
    defaultTitle: "0 каналов",
    arrType: ["канал", "канала", "каналов"],
  })

  const { hasPermission } = usePermission()

  const {
    editData,
    onSaveEdit,
    onCreate,
    resetData,
    onDelete,
    onEditItem,
    onToggleActive,
  } = useManageItems(dataItems, getItems, onSuccessEdit, onSuccessCreate)

  function onSuccessEdit() {
    setEditDrawerState((prev) => !prev)
  }

  function onSuccessCreate() {
    setCreateDrawerState((prev) => !prev)
  }

  const columns = getColumns(
    hasPermission("support-channels.edit") ? onEditItem : null,
    hasPermission("support-channels.delete") ? onDelete : null,
    hasPermission("support-channels.edit") ? onToggleActive : null
  )

  return (
    <>
      <Header
        title={headerTitle}
        extra={
          <ExtraButtons
            onCreate={
              hasPermission("support-channels.create")
                ? () => setCreateDrawerState(true)
                : undefined
            }
            titles={{ onCreate: "Добавить канал" }}
          />
        }
      />

      <StyledTable
        dataSource={dataItems}
        columns={columns}
        loading={isLoading}
        pagination={false}
      />

      {hasPermission("support-channels.create") && (
        <VisibilityProvider visible={createDrawerState}>
          <EditDrawer
            title={"Создание канала связи"}
            onSave={onCreate}
            onClose={() => setCreateDrawerState(!createDrawerState)}
            initialValues={false}
            typeOptions={options.typeOptions}
          />
        </VisibilityProvider>
      )}

      {hasPermission("support-channels.edit") && (
        <VisibilityProvider visible={editDrawerState}>
          <EditDrawer
            title={"Редактирование канала связи"}
            onSave={onSaveEdit}
            onClose={() => {
              setEditDrawerState(!editDrawerState)
              resetData()
            }}
            initialValues={editData}
            typeOptions={options.typeOptions}
          />
        </VisibilityProvider>
      )}
    </>
  )
}

const StyledTable = styled(AntTable)`
  .row-can-view {
    cursor: pointer;
  }
`
